/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ElementTreeListViewModelQueryResult } from '../model/elementTreeListViewModelQueryResult';
import { ElementTreeViewModel } from '../model/elementTreeViewModel';
import { TreeChildrenPaginatedBody } from '../model/treeChildrenPaginatedBody';
import { TreeChildrenPaginatedBody1 } from '../model/treeChildrenPaginatedBody1';
import { TreeChildrenPaginatedBody2 } from '../model/treeChildrenPaginatedBody2';
import { TreeChildrenPaginatedBody3 } from '../model/treeChildrenPaginatedBody3';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TreeService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param elementId 
     * @param elementHierarchyTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getElementChildren(elementId?: number, elementHierarchyTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ElementTreeViewModel>>;
    public getElementChildren(elementId?: number, elementHierarchyTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ElementTreeViewModel>>>;
    public getElementChildren(elementId?: number, elementHierarchyTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ElementTreeViewModel>>>;
    public getElementChildren(elementId?: number, elementHierarchyTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (elementId !== undefined && elementId !== null) {
            queryParameters = queryParameters.set('elementId', <any>elementId);
        }
        if (elementHierarchyTypeId !== undefined && elementHierarchyTypeId !== null) {
            queryParameters = queryParameters.set('elementHierarchyTypeId', <any>elementHierarchyTypeId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ElementTreeViewModel>>('get',`${this.basePath}/v1/Tree/elementChildren`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWbsChildrenElementsPaginated(body?: TreeChildrenPaginatedBody, observe?: 'body', reportProgress?: boolean): Observable<ElementTreeListViewModelQueryResult>;
    public getWbsChildrenElementsPaginated(body?: TreeChildrenPaginatedBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ElementTreeListViewModelQueryResult>>;
    public getWbsChildrenElementsPaginated(body?: TreeChildrenPaginatedBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ElementTreeListViewModelQueryResult>>;
    public getWbsChildrenElementsPaginated(body?: TreeChildrenPaginatedBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ElementTreeListViewModelQueryResult>('post',`${this.basePath}/v1/Tree/ChildrenPaginated`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
